import { render } from "./Dashboard.vue?vue&type=template&id=0e6ffbe2&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=0e6ffbe2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e6ffbe2"

export default script